import { useSearchResultsType } from '~/src/common/components/Search/hooks/useSearchResultsType';
import { TabName, Source, ModelVersion } from '~/src/common/components/Search/types';
import { useFeatureFlag } from '~/src/common/services/FeatureFlag';

import { useSearchParams } from './useSearchParams';

/** Recherche, incluant produits et recettes */
export const useSearchResults = (tabName: TabName) => {
  // Parametres de recherche
  const { term, source: _source } = useSearchParams();
  const isNewSearchAlgoEnabled = useFeatureFlag('nouvel-algo-recherche');
  const modelVersion: ModelVersion = isNewSearchAlgoEnabled ? 'ordinal_df' : undefined;

  // @ts-expect-error - La valeur vient de l'url, typage strict impossible
  // Ici, pas d'utilisation de `as` pour conserver une trace du bricolage
  const source: Source = _source;

  // Récupération des données
  const params = { text: term, source, tabName, modelVersion };
  const recipes = useSearchResultsType('RECIPE', params);
  const products = useSearchResultsType('PRODUCT', params);

  // Utilitaires et retour
  const isLoaded = products.isLoaded && recipes.isLoaded;
  const data = { recipes, products };
  return { term, data, isLoaded };
};
